var _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcec({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 126.40613,
    height: 126.406,
    viewBox: "0 0 126.40613 126.406",
    sodipodidocname: "ECEC.ai",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,94.805 H 94.805 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapegroupmode: "layer",
    inkscapelabel: "ECEC",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,126.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(39.11,38.4426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,0 0.001,0 0.001,0.001 0.001,0 0,0 0,0 0,0 0,0 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(88.8026,62.4147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -2.919,-2.401 -4.68,-3.85 -5.895,-5.897 -1.066,-1.797 -3.893,-7.602 -4.959,-10.183 -1.479,-3.586 -5.756,-8.838 -12.938,-11.836 l -1.371,-0.548 c -5.747,-2.3 -12.262,-4.906 -17.868,-7.196 -1.38,-0.564 -2.661,-0.81 -3.821,-0.81 -3.015,0 -5.208,1.659 -6.185,3.695 -1.067,-1.009 -2.147,-2.047 -2.806,-3.027 -1.357,-2.019 -1.879,-4.04 -2.13,-5.01 -0.085,-0.327 -0.153,-0.564 -0.202,-0.694 -1.148,-3.065 -3.54,-4.888 -6.918,-5.273 -1.317,-0.151 -2.593,-0.397 -3.788,-0.636 -0.157,-0.031 -0.314,-0.043 -0.468,-0.038 -0.917,0.032 -1.726,0.688 -1.913,1.626 -0.22,1.096 0.491,2.162 1.587,2.381 1.223,0.245 2.65,0.52 4.124,0.688 1.867,0.213 2.974,1.037 3.586,2.672 0.01,0.035 0.037,0.146 0.073,0.287 0.283,1.095 0.947,3.661 2.69,6.254 0.942,1.402 2.261,2.65 3.537,3.857 0.86,0.814 1.672,1.582 2.314,2.34 0.243,0.287 0.589,0.835 0.178,1.281 -0.417,0.452 -1.404,0.552 -2.59,-0.294 -0.025,-0.018 -0.05,-0.035 -0.075,-0.052 l -2.551,-1.654 c -0.64,-0.414 -1.28,-0.827 -1.761,-1.136 -0.173,-0.111 -0.357,-0.229 -0.549,-0.34 l -0.252,-0.163 -0.012,0.019 c -0.818,-0.421 -1.756,-0.625 -2.609,0.351 -0.387,0.442 -0.561,1.032 -0.479,1.615 0.082,0.582 0.414,1.1 0.908,1.419 l 4.939,3.18 c 0.935,0.837 2.695,1.505 6.016,2.587 0.558,0.182 1.051,0.342 1.408,0.471 0.972,0.35 1.984,0.589 2.877,0.799 0.569,0.134 1.108,0.261 1.496,0.387 0.927,0.261 1.231,1.011 1.124,1.461 -0.146,0.608 -1.304,1.062 -3.494,0.623 -3.958,-0.667 -8.463,-1.391 -12.48,-2.037 l -1.156,-0.186 c -3.638,-0.643 -6.199,-2.647 -7.025,-4.234 -0.822,-1.579 -3.018,-5.163 -3.978,-6.416 -1.286,-1.679 -2.929,-2.579 -5.203,-3.825 l -0.08,-0.044 c -0.98,-0.537 -2.21,-0.178 -2.748,0.802 -0.537,0.98 -0.177,2.21 0.802,2.747 l 0.081,0.045 c 1.976,1.082 3.168,1.735 3.936,2.737 0.762,0.995 2.815,4.315 3.6,5.823 1.216,2.337 4.55,5.403 9.941,6.356 l 1.188,0.191 c 4.007,0.644 8.501,1.366 12.389,2.021 2.643,0.53 4.579,0.154 5.916,-0.652 0.226,0.799 0.592,1.629 1.143,2.479 1.026,1.581 2.283,3.177 3.499,4.721 1.591,2.019 3.236,4.108 4.251,6.038 1.955,3.715 2.629,7.091 2.953,8.714 0.091,0.452 0.161,0.781 0.216,0.964 1.324,4.464 4.203,7.5 8.557,9.023 1.909,0.668 3.742,1.464 5.456,2.223 1.023,0.452 2.218,-0.01 2.67,-1.032 0.452,-1.022 -0.01,-2.217 -1.032,-2.669 -1.789,-0.792 -3.707,-1.625 -5.757,-2.343 -3.1,-1.084 -5.067,-3.162 -6.014,-6.354 -0.033,-0.119 -0.072,-0.327 -0.127,-0.605 -0.333,-1.667 -1.113,-5.573 -3.341,-9.806 -1.187,-2.258 -2.949,-4.494 -4.652,-6.657 -1.213,-1.54 -2.359,-2.995 -3.284,-4.421 -1.068,-1.645 -0.897,-2.922 -0.288,-3.414 0.831,-0.67 2.706,-0.307 4.679,1.683 0.017,0.017 0.035,0.035 0.053,0.052 h 0.001 c 0,0 1.773,1.66 3.548,3.317 0.89,0.83 1.78,1.659 2.45,2.279 0.268,0.248 0.526,0.487 0.776,0.7 l 0.343,0.319 0.023,-0.024 c 0.871,0.657 1.688,0.908 2.658,0.093 0.784,-0.659 0.951,-1.802 0.39,-2.66 -0.09,-0.136 -0.195,-0.262 -0.315,-0.374 l -6.978,-6.485 c -1.179,-1.496 -4.101,-3.253 -8.05,-5.54 -0.802,-0.464 -1.511,-0.873 -2.023,-1.19 -1.305,-0.804 -2.702,-1.476 -3.935,-2.069 -0.828,-0.398 -1.611,-0.775 -2.203,-1.116 -1.712,-0.909 -1.96,-2.349 -1.473,-3.388 0.522,-1.117 2.104,-2.024 4.837,-0.905 5.621,2.295 12.143,4.904 17.897,7.206 l 1.343,0.538 c 5.627,2.349 9.449,6.533 10.728,9.633 1.162,2.815 4.04,8.717 5.219,10.704 1.577,2.657 3.657,4.368 6.805,6.958 l 0.11,0.091 C -1.598,3.926 -0.322,3.802 0.388,2.94 1.098,2.076 0.974,0.801 0.111,0.091 Z M -18.518,26.491 C -41.44,39.129 -70.266,30.792 -82.904,7.87 c -12.638,-22.922 -4.3,-51.748 18.621,-64.386 22.922,-12.637 51.749,-4.301 64.386,18.621 12.638,22.922 4.301,51.749 -18.621,64.386",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcec);
export default __webpack_public_path__ + "static/media/ECEC.d136a7932a5e81b79242ec47240177c2.svg";
export { ForwardRef as ReactComponent };